module.exports = __webpack_public_path__ + "static/media/59 - Yellowman - Zungguzungguguzungguzeng.b64e27cc.mp3";